module.exports = __webpack_public_path__ + "media/images/emblems/Autigny-coat_of_arms-41debf8fa42f5bbfc6693140cec290c3.svg";